import React, { Fragment, createRef } from "react";
import axios from "axios/dist/axios.min.js";
import utils from "../../../utils/utils";
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper.less";
import "./index.less";
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      num: 8, // 九宫格：8   12宫格：12
      allAwards: props.prize_list,
      count: 0, // 九宫格的下标
      times: 60, // 跳到下一个格子需要的时间
      timer: null, // 定时器
      nowTime: null,
      awardsId: null,
      isRolling: false,
      trophy: null, //奖品
      visible: false, //控制弹窗
      success_show: false,
      mask_show_end: false,
      retain_show: false,
      beganClick: 0,
      winnerList: [],
      remain_status: false
    };
    this.swiperRef = createRef();
    this.handleBegan = this.handleBegan.bind(this);
    this.decelerate = this.decelerate.bind(this);
  }
  /***
   * 点击抽奖按钮
   */
  handleBegan() {
    utils.uploadTrack(this.props.props, {}, {
      blockName: 'start'
    });
    if (!this.state.isRolling) {
      // 初始化数据之后才可以开始
      this.setState(
        {
          count: 0,
          times: 60,
          timer: null,
          nowTime: null,
          awardsId: null,
          isRolling: true,
          nowTime: new Date(),
          beganClick: 1,
        },
        () => {
          this.handlePlay();
        }
      );
    }
  }
  // 开始抽奖
  handlePlay() {
    let timer = setTimeout(() => {
      let con = this.state.count;
      if (this.state.num == 8 && con === 7) {
        con = 0;
      } else if (this.state.num == 12 && con === 11) {
        con = 0;
      } else {
        con++;
      }
      this.setState({
        count: con,
      });
      if (new Date() - this.state.nowTime > 480) {
        this.decelerate();
      }
      if (this.state.isRolling) {
        this.handlePlay();
      }
    }, this.state.times);
    this.setState({
      timer: timer,
    });
  }
  /***
   * 减速
   */
  decelerate() {
    if (
      new Date() - this.state.nowTime >= 480 &&
      new Date() - this.state.nowTime < 1480
    ) {
      this.setState({
        times: 125, //控制速度减的快慢
      });
    } else if (
      new Date() - this.state.nowTime >= 1480 &&
      new Date() - this.state.nowTime < 3080
    ) {
      this.setState({
        times: 200, //控制速度减的快慢
      });
    } else {
      this.setState({
        times: 300, //控制速度减的快慢
      });
    }

    // 模拟从后端获取到的中奖的数据
    this.setState({
      awardsId: 3,
    });
    // }
    // 判断获取的中奖id和当前id相同，则停止。
    if (
      this.state.times == 300 &&
      this.state.count == 2
      // this.state.awardsId === this.state.allAwards[this.state.count].id
    ) {
      clearTimeout(this.state.timer);
      this.state.isRolling = false;
      utils.uploadTrack(this.props.props, {}, {
        blockName: 'winning-show'
      });
      this.setState({
        success_show: true,
        mask_show_end: true,
      });
    }
  }
  // 获取轮播数据
  getLubnoData = () => {
    axios({
      url: `//sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi//new_draw/lunbo?unique_id=${this.props.unique_id}`,
      method: "get",
      withCredentials: true,
    }).then((res) => {
      const { data, status } = res.data;
      if (status === 0) {
        const { res } = data;
        this.setState(
          {
            winnerList: res,
          },
          () => {
            const swiper = new Swiper(this.swiperRef.current, {
              direction: "vertical",
              loop: true,
              autoplay: {
                delay: 1000, //1秒切换一次
              },
              noSwiping: true,
              speed: 300,
            });
          }
        );
      }
    });
  };

  componentDidMount() {
    const { draw } = this.props
    draw.coupons = draw.coupons ? draw.coupons : [];
    if (draw.coupons.length) {
      this.remainFun();
    }
    this.getLubnoData();
  }

  remainFun = () => {
    let leaveStatus = 0;
    let tit = document.title;
    let path = "";
    const search = window.location.search;
    // 首次进入页面时才加入#leaveStatus；当只是刷新页面时，不再重复加入#leaveStatus
    if (search && !utils.getParams('leaveStatus')) {
      path = `${search}&leaveStatus=1`;
      // 将追加了hash的链接推入history中
      window.history.pushState(
        {
          title: tit,
          path: path,
        },
        tit,
        path
      );
    }
    // if (window.location.hash != "#leaveStatus") {
    //   path = window.location.href.replace(/#.*$/, "") + "#leaveStatus";
    //   // 将追加了hash的链接推入history中
    //   window.history.pushState(
    //     {
    //       title: tit,
    //       path: path,
    //     },
    //     tit,
    //     path
    //   );
    // }
    leaveStatus = 1;
    window.addEventListener("popstate", (ev) => {
      if (leaveStatus == 1) {
        leaveStatus = 0;
        console.log('11111',"remain_status")
        this.setState({
          retain_show: true,
          mask_show_end: true,
          success_show: false,
        });
      }
    });
    // const {remain_status} = this.state
    // if(!remain_status) {
    //   this.setState({
    //     remain_status: true
    //   })
    // } 
    // console.log(remain_status,"remain_status")
    // window.addEventListener("popstate", (ev) => {
    //   console.log(remain_status,"remain_status")
    //   if (remain_status) {
    //     this.setState({
    //       retain_show: true,
    //       mask_show_end: true,
    //       success_show: false,
    //       remain_status: false
    //     });
    //   }
    // });
  };
  remainFun2 = () => {
    let leaveStatus = 0;
    window.addEventListener("load", () => {
      let tit = document.title;
      let path = "";
      //首次进入页面时才加入#leaveStatus；当只是刷新页面时，不再重复加入#leaveStatus
      if (window.location.hash != "ban_back") {
        window.location.hash = "ban_back";
        leaveStatus = 1;
      }
    });
    if (!leaveStatus) {
      window.addEventListener("hashchange", () => {
        this.setState({
          retain_show: true,
          mask_show_end: true,
        });
      });
    }
  };

  closeAwardPop = () => {
    this.setState({
      success_show: false,
      mask_show_end: false,
    });
  };

  closeRetainPop = () => {
    this.setState({
      retain_show: false,
      mask_show_end: false,
    });
    // window.history.go(-1)
  };
  render() {
    const {
      page_show,
      draw,
      prize_list,
      count_down,
      mask_show_prop,
      prize_show,
      lucky_count,
      lucky_image,
      rule_show,
      handleJump,
      closePopup,
      handleDownLoad,
    } = this.props;
    const {
      winnerList,
      success_show,
      mask_show_end,
      retain_show,
      count,
      beganClick,
    } = this.state;
    draw.coupons = draw.coupons ? draw.coupons : [];
    return (
      <div className="pipeline-lottery2" {...this.props["customAttributes"]}>
        <div
          className="games-area"
          style={{
            backgroundImage: `url(${draw.outside_bgimg ||
              "https://static.shihuocdn.cn/admin/files/20221110/5f7b0f0fce3f76df803ccbaa4471fc16.png"})`,
          }}
        >
          <div className="games-content">
            <div
              className="swiper"
              ref={this.swiperRef}
              style={{
                backgroundImage: `url(${draw.lantern_pic ||
                  "https://static.shihuocdn.cn/admin/files/20221111/487a42158d1e4bf4cd9956480bb05266.png"})`,
              }}
            >
              <div className="swiper-wrapper">
                {winnerList.map((item, index) => {
                  return (
                    <div className="swiper-slide swiper-no-swiping" key={`slide-${index}`}>
                      <div
                        style={{ backgroundImage: `url(${item.avatar})` }}
                        className="swiper-avatar"
                      />
                      <div
                        className="swiper-title"
                        style={{ color: draw.font_color }}
                      >
                        {item.title}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div
              className="backGameImg"
              style={{
                backgroundImage: `url(${draw.back_pic ||
                  "https://static.shihuocdn.cn/admin/files/20221113/fefd2e4655d2cf9cc1f68ab48b7cf688.png"})`,
              }}
            >
              <ul
                className={
                  "award-container " +
                  (this.state.num === 12 ? "award-container-handle" : "")
                }
              >
                {prize_list.length &&
                  prize_list.map((item, index) => {
                    let shows = "shade";
                    // shows += this.state.count === index ? ' show' : ''
                    shows = count === index && beganClick ? " shade" : "";
                    return (
                      <li
                        key={item.id + "" + index}
                        className={
                          "award-item award-item-left award-item-" + index
                        }
                      >
                        <div
                          className={"base-img"}
                          style={{
                            backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221113/a5a79139c02f603e229b37c4affc598a.png')`,
                          }}
                        >
                          {
                            <div
                              className={shows}
                              style={{
                                backgroundImage: `url(${draw.select_pic ||
                                  "https://static.shihuocdn.cn/admin/files/20221121/5e434218fe2ce7f2a0f9fe41fe3422a7.png"})`,
                              }}
                            />
                          }
                          <img
                            className="base-goods-img"
                            src={prize_list[index].prize_pic[0]}
                            // src="https://static.shihuocdn.cn/admin/files/20221115/ffe553085d1d2cd44f5c931f487925d4.png"
                          />
                          {/* <div className="base-goods-name">Nike dunk粉白</div> */}
                          <div className="base-goods-name">
                            {prize_list[index].prize_name}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                <li
                  className={[
                    "award-item award-item-handle " +
                      (this.state.num === 12 ? "award-item-handle-12" : ""),
                    `${!beganClick ? "award-item-handle-animate" : ""}`,
                  ].join(" ")}
                  style={{
                    backgroundImage: `url(${draw.button_static ||
                      "https://static.shihuocdn.cn/admin/files/20221123/53b5e88522033648f154fe5a252422b7.png"})`,
                  }}
                  onClick={this.handleBegan}
                ></li>
              </ul>
              {!beganClick && (
                <div
                  onClick={this.handleBegan}
                  className="teach-touch"
                  style={{
                    backgroundImage: `url(${draw.finger_pic ||
                      "https://static.shihuocdn.cn/admin/imgs/20221209/f71dc39e2fdd50382bb99f8bb91ca925_240x240.png"})`,
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="persuade_turntableGame">
          <img
            src={
              draw.outside_bgimg_2
                ? draw.outside_bgimg_2
                : "https://static.shihuocdn.cn/admin/files/20221110/5ac88480da4b44701eb9ee91b0f5229d.png"
            }
            className="bg-image"
          />
        </div>
        {/* 蒙层 */}
        {(mask_show_end || mask_show_prop) && <div className="mask"></div>}

        {/* 奖品列表 */}
        {prize_show && (
          <div
            style={{
              backgroundImage: `url(${
                draw.prize_popup
                  ? draw.prize_popup
                  : "https://static.shihuocdn.cn/admin/files/20221114/a99ff3bac45c341979cfdc0081665ef7.png"
              })`,
            }}
            className="prize-list"
          >
            {prize_list && prize_list.length > 0 && (
              <Fragment>
                <img
                  src={prize_list[2] && prize_list[2].prize_pic[0]}
                  // src={
                  //   "https://static.shihuocdn.cn/admin/files/20221115/44a78a2b729c45810d0a3356054ab417.png"
                  // }
                  alt=""
                  className="img-middle"
                />
                <div className="rec-goods-message">
                  <div className="rec-goods-name">
                    {/* Nike dunk White/Black低帮 粉白 */}
                    {prize_list[2] && prize_list[2].prize_name}
                  </div>
                  <span className="rec-goods-price">{draw.outside_desc}</span>
                </div>

                <div
                  className="count-down"
                  onClick={() => {
                    handleJump();
                  }}
                >
                  <span>跳过{count_down}</span>
                </div>
              </Fragment>
            )}
          </div>
        )}

        {/* 光晕效果 */}
        {prize_show && (
          <div
            className="light"
            style={{
              backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221201/a6be95474811c79b2fd43eb890bc38d7.png')`,
            }}
          ></div>
        )}

        {/* 中奖弹窗有优惠劵 */}
        {success_show && (
          <div
            className={[
              "success-info",
              `${!draw.coupons.length ? "success-info2" : null}`,
            ].join(" ")}
            style={{
              backgroundImage: `url(${
                draw.winprize_popup
                  ? draw.winprize_popup
                  : "https://static.shihuocdn.cn/admin/files/20221207/e0b7b7d9601be79928aaf03ebf741fcc.png"
              })`,
            }}
            // style={{
            //   backgroundImage: `url(https://static.shihuocdn.cn/admin/files/20221121/e037a516850608cc31ffe2445c73338c.png)`,
            // }}
          >
            {prize_list && prize_list.length > 0 && (
              <Fragment>
                <div className="prize-info">
                  <img
                    src={prize_list[2] && prize_list[2].prize_pic[0]}
                    // src={
                    //   "https://static.shihuocdn.cn/admin/files/20221115/44a78a2b729c45810d0a3356054ab417.png"
                    // }
                    className="prize-image"
                  />
                  <p className="prize-name">
                    {/* {"Nike dunk White/Black低帮 粉白"} */}
                    {prize_list[2] && prize_list[2].prize_name}
                  </p>
                  <p className="prize-desc">{draw.outside_desc}</p>
                  {draw.outside_download_img && (
                    <img
                      // src={draw.outside_download_img}
                      src={
                        draw.outside_download_img ||
                        "https://static.shihuocdn.cn/admin/files/20221115/5eef5c1f14288557265fdffc3b619e4c.png"
                      }
                      alt=""
                      className="download-btn"
                      onClick={() => {
                        handleDownLoad();
                      }}
                    />
                  )}
                </div>
                <div className="prize-coupons">
                  {draw.coupons.length == 1 && (
                    <div
                      className="prize-coupons-background"
                      style={{
                        backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221116/96ed3ec223e9e604bfe04ffcd7eccd37.png')`,
                      }}
                    >
                      <div className="prize-coupons-price">
                        <span>¥</span>
                        {draw.coupons[0].price.length <= 3
                          ? draw.coupons[0].price
                          : draw.coupons[0].price.toString().substring(0, 3)}
                      </div>
                      <div className="prize-coupons-dec">
                        {/* <p>识货补贴</p>
                        <p>仅限新用户</p> */}
                        <p>{draw.coupons[0].title}</p>
                        <p>{draw.coupons[0].sub_title}</p>
                      </div>
                    </div>
                  )}
                  {draw.coupons.length == 2 && (
                    <div>
                      <div
                        className="prize-coupons-background-left"
                        style={{
                          backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')`,
                        }}
                      >
                        <div className="prize-coupons-price-left">
                          <span>¥</span>
                          {draw.coupons[0].price.length <= 3
                            ? draw.coupons[0].price
                            : draw.coupons[0].price.toString().substring(0, 3)}
                        </div>
                        <div className="prize-coupons-dec-left">
                          {/* <p>识货补贴我的</p>
                          <p>仅限新用户我的</p> */}
                          <p>{draw.coupons[0].title}</p>
                          <p>{draw.coupons[0].sub_title}</p>
                        </div>
                      </div>
                      <div
                        className="prize-coupons-background-right"
                        style={{
                          backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')`,
                        }}
                      >
                        <div className="prize-coupons-price-right">
                          <span>¥</span>
                          {draw.coupons[1].price.length <= 3
                            ? draw.coupons[1].price
                            : draw.coupons[1].price.toString().substring(0, 3)}
                        </div>
                        <div className="prize-coupons-dec-right">
                          {/* <p>品牌专享劵我的</p>
                          <p>无门槛我的我</p> */}
                          <p>{draw.coupons[1].title}</p>
                          <p>{draw.coupons[1].sub_title}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <img
                  src="https://static.shihuocdn.cn/admin/files/20221226/ceab8c8de1a6373675898799f28e1e0d.png"
                  alt=""
                  className="close"
                  onClick={this.closeAwardPop.bind(this)}
                />
              </Fragment>
            )}
          </div>
        )}

        {/* 挽留弹窗 */}
        {retain_show && (
          <div
            className={["success-info", `"success-info2" : null}`].join(" ")}
            style={{
              backgroundImage: `url(${
                draw.retain_pic
                  ? draw.retain_pic
                  : "https://static.shihuocdn.cn/admin/files/20221124/60290b84d47e37e4470b45b2d2e21ef5.png"
              })`,
            }}
            // style={{
            //   backgroundImage: `url(https://static.shihuocdn.cn/admin/files/20221121/e037a516850608cc31ffe2445c73338c.png)`,
            // }}
          >
            {prize_list && prize_list.length > 0 && (
              <Fragment>
                <div className="prize-info">
                  <img
                    src={prize_list[2] && prize_list[2].prize_pic[0]}
                    // src={
                    //   "https://static.shihuocdn.cn/admin/files/20221115/44a78a2b729c45810d0a3356054ab417.png"
                    // }
                    className="prize-image"
                  />
                  <p className="prize-name">
                    {/* {"Nike dunk White/Black低帮 粉白"} */}
                    {prize_list[2] && prize_list[2].prize_name}
                  </p>
                  <p className="prize-desc">{draw.outside_desc}</p>
                  {draw.outside_download_img && (
                    <img
                      // src={draw.outside_download_img}
                      src={
                        draw.outside_download_img ||
                        "https://static.shihuocdn.cn/admin/files/20221115/5eef5c1f14288557265fdffc3b619e4c.png"
                      }
                      alt=""
                      className="download-btn"
                      onClick={() => {
                        handleDownLoad();
                        this.setState({
                          retain_show: false,
                          mask_show_end: false,
                        });
                      }}
                    />
                  )}
                </div>
                <div className="prize-coupons">
                  {draw.coupons.length == 1 && (
                    <div
                      className="prize-coupons-background"
                      style={{
                        backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221116/96ed3ec223e9e604bfe04ffcd7eccd37.png')`,
                      }}
                    >
                      <div className="prize-coupons-price">
                        <span>¥</span>
                        {draw.coupons[0].price.length <= 3
                          ? draw.coupons[0].price
                          : draw.coupons[0].price.toString().substring(0, 3)}
                      </div>
                      <div className="prize-coupons-dec">
                        {/* <p>识货补贴</p>
                        <p>仅限新用户</p> */}
                        <p>{draw.coupons[0].title}</p>
                        <p>{draw.coupons[0].sub_title}</p>
                      </div>
                    </div>
                  )}
                  {draw.coupons.length == 2 && (
                    <div>
                      <div
                        className="prize-coupons-background-left"
                        style={{
                          backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')`,
                        }}
                      >
                        <div className="prize-coupons-price-left">
                          <span>¥</span>
                          {draw.coupons[0].price.length <= 3
                            ? draw.coupons[0].price
                            : draw.coupons[0].price.toString().substring(0, 3)}
                        </div>
                        <div className="prize-coupons-dec-left">
                          <p>{draw.coupons[0].title}</p>
                          <p>{draw.coupons[0].sub_title}</p>
                        </div>
                      </div>
                      <div
                        className="prize-coupons-background-right"
                        style={{
                          backgroundImage: `url('https://static.shihuocdn.cn/admin/files/20221116/7de41170d33ce20af9ea8a98511d1b52.png')`,
                        }}
                      >
                        <div className="prize-coupons-price-right">
                          <span>¥</span>
                          {draw.coupons[1].price.length <= 3
                            ? draw.coupons[1].price
                            : draw.coupons[1].price.toString().substring(0, 3)}
                        </div>
                        <div className="prize-coupons-dec-right">
                          <p>{draw.coupons[1].title}</p>
                          <p>{draw.coupons[1].sub_title}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <img
                  src="https://static.shihuocdn.cn/admin/files/20221115/8bcb9ed30a362b966228ddbfbffe270e.png"
                  alt=""
                  className="close"
                  onClick={this.closeRetainPop.bind(this)}
                />
              </Fragment>
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pipeline-lottery/turntableGame/index.js